import _axios from "../api";

export const addCase = async (caseManagerModel) =>
  await _axios.post(`/case/add`, JSON.stringify(caseManagerModel)).then((response) => {
    return response.data;
  });

export const GetCaseBYId = (CaseManagerDetailId) => {
  return _axios.get(`/case/edit/${CaseManagerDetailId}`).then((response) => {
    return response.data;
  });
};

export const getCaseList = async (qryparam) => {
  const params = {
    ...qryparam,
    ApplicationStatusMasterIds: Array.isArray(qryparam.ApplicationStatusMasterIds)
      ? qryparam.ApplicationStatusMasterIds.join(",")
      : qryparam.ApplicationStatusMasterIds || ""
  };
  const response = await _axios.get(`/case/list/`, {
    params: params
  });
  return response.data;
};

export const deleteCase = async (id, value) =>
  await _axios.post(`/case/${id}/${value}`).then((response) => {
    return response.data;
  });

export const updateCase = async (caseManagerModel) =>
  await _axios.post(`/case/Update`, JSON.stringify(caseManagerModel)).then((response) => {
    return response.data;
  });

export const getComplatedCaseCountbyUser = (authorityId, month) => {
  return _axios.get(`/case/user-summary/${authorityId}/${month}`).then((response) => {
    return response.data;
  });
};

export const getCaseChartList = async (qryparam) => {
  const queryString = Object.keys(qryparam)
    .map((key) => {
      if (qryparam[key] === null) {
        return `${encodeURIComponent(key)}=NULL`;
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(qryparam[key])}`;
    })
    .join("&");

  const response = await _axios.get(`/case/chartList/?${queryString}`);
  return response.data;
};

export const getSearchList = async (qry) => {
  if (typeof qry !== "object" || qry === null) {
    return;
  }
  const response = await _axios.get(`/caseSearch/list/`, {
    params: qry
  });
  return response.data;
};

export const pinCase = async (id, value) =>
  await _axios.post(`/pin/${id}/${value}`).then((response) => {
    return response.data;
  });

export const downloadCaseExcel = async (qry) => {
  return await _axios.get(`/caseexcel/list?${qry}`, {
    responseType: "blob"
  });
};

export const downloadCaseReport = async (qry) => {
  return await _axios.get(`/casereport/list?${qry}`, {
    responseType: "blob"
  });
};
export const managecasetypework = async (caseManagerDetailId, authorityId, data) => {
  const response = await _axios.put("/casetypework/managecasetypework", data, {
    params: {
      caseManagerDetailId: caseManagerDetailId,
      authorityId: authorityId
    }
  });
  return response.data;
};

export const getContractorEstimateConfigList = async () =>
  await _axios.get(`contractor-estimate-config/list`).then((response) => {
    return response.data;
  });
